import { Card, CardContent } from "@material-ui/core";
import React, { Component } from "react";
import { Notice } from "../../../../_metronic/_partials/controls";

class DashboardPelaksanaan extends Component {
  render() {
    const systems = [
      {
        title: "Pendidikan",
        name: "Pangkalan Data Pendidikan Tinggi (PDDikti)",
        url: "https://pddikti.kemdiktisaintek.go.id",
        logo: "logo-pddikti.svg",
      },
      {
        title: "Penelitian",
        name: "Basis Informasi Penelitian dan Pengabdian kepada Masyarakat",
        url: "https://bima.kemdiktisaintek.go.id",
        logo: "logo-bima.png",
      },
      {
        title: "Pengabdian kepada Masyarakat",
        name: "Basis Informasi Penelitian dan Pengabdian kepada Masyarakat",
        url: "https://bima.kemdiktisaintek.go.id",
        logo: "logo-bima.png",
      },
      {
        title: "Sumberdaya",
        name: "Sistem Informasi Sumberdaya Terintegrasi",
        url: "https://sister.kemdiktisaintek.go.id/",
        logo: "logo-sister.png",
      },
      {
        title: "Kemahasiswaan",
        name: "Sistem Informasi Kinerja dan Tata Kelola Kemahasiswaan",
        url: "https://simkatmawa.kemdiktisaintek.go.id",
        logo: "logo-kemdikbud.svg",
      },
      {
        title: "Kerjasama",
        name: "Sistem Pelaporan Kerjasama",
        url: "https://laporankerma.kemdiktisaintek.go.id",
        logo: "logo-kerma.png",
      },
      {
        title: "Kelembagaan",
        name: "Sistem Informasi Kelembagaan",
        url: "https://siaga.kemdiktisaintek.go.id/",
        logo: "logo-kemdikbud.svg",
      },
      {
        title: "IKU",
        name: "Dashboard Indikator Kinerja Utama Perguruan Tinggi",
        url: "https://iku-pt.kemdiktisaintek.go.id/",
        logo: "logo-pddikti.svg",
      },
      {
        title: "RPL",
        name: "Sistem E-Rekomendasi Rekognisi Pembelajaran Lampau",
        url: "https://sierra.kemdiktisaintek.go.id",
        logo: "logo-sierra.png",
      },
    ];

    return (
      <>
        <Notice
          svg="/media/svg/icons/Home/Building.svg"
          style={{ marginBottom: "20px", boxShadow: "none" }}
        >
          <strong style={{ fontSize: "18px" }}>Pelaksanaan</strong>
          <p>Standar Nasional Pendidikan Tinggi</p>
        </Notice>

        <Card>
          <CardContent>
            <p style={{ marginBottom: "20px", color: "#555" }}>
              Pelaksanaan SN Dikti pada setiap perguruan tinggi dilaporkan melalui sistem informasi terintegrasi yang disiapkan oleh Kemdiktisaintek baik untuk Standar Akademik maupun Nonakademik, seperti:
            </p>

            <div className="row">
              {systems.map((item, index) => (
                <div className="col-lg-4 col-md-6 col-sm-12 mb-5" key={index}>
                <Card
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    padding: "20px",
                    borderRadius: "14px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    transition: "all 0.25s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-6px)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 20px rgba(0,0,0,0.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 8px rgba(0,0,0,0.05)";
                  }}
                >
                  <div style={{ marginBottom: "12px" }}>
                    <img
                      src={`/media/logos/${item.logo}`}
                      alt={item.title}
                      style={{
                        height: "40px",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  <h5 style={{ marginBottom: "8px" }}>{item.title}</h5>

                  <p style={{ fontSize: "13px", color: "#777", flexGrow: 1 }}>
                    {item.name}
                  </p>

                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      marginTop: "10px",
                      padding: "8px 14px",
                      fontSize: "13px",
                      color: "#fff",
                      background: "#3699FF",
                      borderRadius: "6px",
                      textDecoration: "none",
                      transition: "all 0.2s ease",
                      textAlign: "center",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#187DE4";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "#3699FF";
                    }}
                  >
                    Kunjungi Sistem →
                  </a>
                </Card>
                </div>
              ))}
            </div>

            <div style={{ marginTop: "24px" }}>
              <p style={{ fontSize: "13px", color: "#666" }}>
                Selain melalui sistem di atas, pelaporan juga dapat dilakukan
                melalui sistem informasi yang disediakan oleh Lembaga Layanan
                Pendidikan Tinggi (LLDIKTI) di wilayah masing-masing.
              </p>
            </div>
          </CardContent>
        </Card>
      </>
    );
  }
}

export default DashboardPelaksanaan;